module.exports = __webpack_public_path__ + "img/mdm-deploy-4.05fa1071.jpg";